import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }
const _hoisted_5 = {
  key: 0,
  class: "d-flex align-items-center gap-3 flex-wrap mb-3"
}
const _hoisted_6 = { class: "dropdown" }
const _hoisted_7 = { class: "dropdown-menu dropdown-menu-right dropdown-menu-scrollable" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "dropdown ml-3" }
const _hoisted_10 = { class: "dropdown-menu dropdown-menu-right dropdown-menu-scrollable" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "toolbar mt-5 d-flex justify-content-between align-items-center" }
const _hoisted_14 = { class: "search-container" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "table table-bordered table-hover" }
const _hoisted_17 = { style: {"width":"40px","min-width":"40px !important"} }
const _hoisted_18 = { class: "btn-group" }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = { class: "d-flex flex-wrap" }
const _hoisted_21 = { class: "dropdown-menu" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UsersAssignerDialog = _resolveComponent("UsersAssignerDialog")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_UsersAssignerDialog, {
      viewModel: _ctx.usersAssignerDialog,
      onAssignUsers: _ctx.handleBulkAssignUsersCommand
    }, null, 8 /* PROPS */, ["viewModel", "onAssignUsers"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.tchProjectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, "Assign " + _toDisplayString(_ctx.rm?.AlternativesLabel), 1 /* TEXT */)
        ])
      ]),
      _cache[24] || (_cache[24] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
      (_ctx.rm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createCommentVNode(" List Filter Dropdown "),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn", _ctx.filterByListId ? 'btn-info' : 'btn-outline-secondary']),
                type: "button",
                "data-toggle": "dropdown"
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fas fa-filter mr-1", _ctx.filterByListId ? 'text-warning' : 'text-muted'])
                }, null, 2 /* CLASS */),
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "List", -1 /* CACHED */))
              ], 2 /* CLASS */),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("a", {
                  class: _normalizeClass(["dropdown-item", { 'active': _ctx.filterByListId === null }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setFilterByList(null)))
                }, " Any / No filter ", 2 /* CLASS */),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                _cache[10] || (_cache[10] = _createElementVNode("h6", { class: "dropdown-header" }, "Filter by list", -1 /* CACHED */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rm.Lists, (l) => {
                  return (_openBlock(), _createElementBlock("a", {
                    class: _normalizeClass(["dropdown-item", { 'active': _ctx.filterByListId === l.Id }]),
                    key: l.Id,
                    onClick: ($event: any) => (_ctx.setFilterByList(l.Id))
                  }, _toDisplayString(l.Name), 11 /* TEXT, CLASS, PROPS */, _hoisted_8))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]),
            _createCommentVNode(" Contributor Filter Dropdown "),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn", _ctx.filterByUserId !== null ? 'btn-info' : 'btn-outline-secondary']),
                type: "button",
                "data-toggle": "dropdown"
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fas fa-filter mr-1", _ctx.filterByUserId !== null ? 'text-warning' : 'text-muted'])
                }, null, 2 /* CLASS */),
                _cache[11] || (_cache[11] = _createElementVNode("span", null, "Contributor", -1 /* CACHED */))
              ], 2 /* CLASS */),
              _createElementVNode("div", _hoisted_10, [
                _createCommentVNode(" Reset filter (show all) "),
                _createElementVNode("a", {
                  class: _normalizeClass(["dropdown-item", { 'active': _ctx.filterByUserId === null }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setFilterByUser(null)))
                }, " Any / No filter ", 2 /* CLASS */),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                _cache[13] || (_cache[13] = _createElementVNode("h6", { class: "dropdown-header" }, "Filter by user", -1 /* CACHED */)),
                _createCommentVNode(" Regular users "),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                  return (_openBlock(), _createElementBlock("a", {
                    class: _normalizeClass(["dropdown-item", { 'active': _ctx.filterByUserId === user.Id }]),
                    key: user.Id,
                    onClick: ($event: any) => (_ctx.setFilterByUser(user.Id))
                  }, _toDisplayString(user.Name), 11 /* TEXT, CLASS, PROPS */, _hoisted_11))
                }), 128 /* KEYED_FRAGMENT */)),
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                _createCommentVNode(" Unassigned (no contributors) "),
                _createElementVNode("a", {
                  class: _normalizeClass(["dropdown-item", { 'active': _ctx.filterByUserId === -1 }]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setFilterByUser(-1)))
                }, " Unassigned ", 2 /* CLASS */)
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.rm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createCommentVNode(" Search Input (Left) "),
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchPhrase) = $event)),
                  class: "form-control form-control-sm",
                  placeholder: "Search..."
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.searchPhrase]
                ])
              ]),
              _createCommentVNode(" Assign Selected Button (Right) "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-primary d-flex align-items-center",
                disabled: _ctx.noneSelected,
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showBulkUsersAssignerDialog && _ctx.showBulkUsersAssignerDialog(...args)))
              }, [
                _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fas fa-users-cog mr-2" }, null, -1 /* CACHED */)),
                _createTextVNode(" Assign (" + _toDisplayString(_ctx.selected.length) + ") ", 1 /* TEXT */)
              ], 8 /* PROPS */, _hoisted_15)
            ]),
            _createElementVNode("table", _hoisted_16, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      (_ctx.noneSelected)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "pointer",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.selectAll && _ctx.selectAll(...args)))
                          }, [...(_cache[16] || (_cache[16] = [
                            _createElementVNode("i", { class: "fa-regular fa-square" }, null, -1 /* CACHED */)
                          ]))]))
                        : _createCommentVNode("v-if", true),
                      (_ctx.anySelected && !_ctx.allSelected)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            class: "pointer",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.unselectAll && _ctx.unselectAll(...args)))
                          }, [...(_cache[17] || (_cache[17] = [
                            _createElementVNode("i", { class: "fa fa-minus-square" }, null, -1 /* CACHED */)
                          ]))]))
                        : _createCommentVNode("v-if", true),
                      (_ctx.anySelected && _ctx.allSelected)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            class: "pointer",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.unselectAll && _ctx.unselectAll(...args)))
                          }, [...(_cache[18] || (_cache[18] = [
                            _createElementVNode("i", { class: "fa-solid fa-square-check" }, null, -1 /* CACHED */)
                          ]))]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _createElementVNode("th", null, _toDisplayString(_ctx.rm.AlternativeLabel), 1 /* TEXT */),
                  _cache[19] || (_cache[19] = _createElementVNode("th", null, "Contributor(s)", -1 /* CACHED */)),
                  _cache[20] || (_cache[20] = _createElementVNode("th", { style: {"width":"120px"} }, null, -1 /* CACHED */))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alternativesView, (p) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: p.Id
                  }, [
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => ((p.IsUiSelected) = $event)
                      }, null, 8 /* PROPS */, _hoisted_19), [
                        [_vModelCheckbox, p.IsUiSelected]
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(p.Name), 1 /* TEXT */),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.UserIds, (uId) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "dropdown d-inline-block position-relative mr-2 mb-1",
                            key: uId
                          }, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["btn btn-sm badge dropdown-toggle px-2 py-1 user-badge", _ctx.filterByUserId === uId ? 'badge-info' : 'badge-secondary']),
                              type: "button",
                              "data-toggle": "dropdown",
                              "aria-expanded": "false"
                            }, _toDisplayString(_ctx.getUserName(uId)), 3 /* TEXT, CLASS */),
                            _createElementVNode("div", _hoisted_21, [
                              _createCommentVNode(" Filter option "),
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                onClick: ($event: any) => (_ctx.setFilterByUser(uId))
                              }, [...(_cache[21] || (_cache[21] = [
                                _createElementVNode("i", { class: "fas fa-filter mr-2" }, null, -1 /* CACHED */),
                                _createTextVNode(" Filter by user ", -1 /* CACHED */)
                              ]))], 8 /* PROPS */, _hoisted_22),
                              _createCommentVNode(" Unassign option "),
                              _createElementVNode("a", {
                                class: "dropdown-item text-danger",
                                onClick: ($event: any) => (_ctx.handleUnassignUserCommand(p, uId))
                              }, [...(_cache[22] || (_cache[22] = [
                                _createElementVNode("i", { class: "fas fa-user-slash mr-2" }, null, -1 /* CACHED */),
                                _createTextVNode(" Unassign ", -1 /* CACHED */)
                              ]))], 8 /* PROPS */, _hoisted_23)
                            ])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-outline-primary d-flex align-items-center",
                        onClick: ($event: any) => (_ctx.showUsersAssignerDialog(p))
                      }, [...(_cache[23] || (_cache[23] = [
                        _createElementVNode("i", { class: "fas fa-user-plus mr-1" }, null, -1 /* CACHED */),
                        _createTextVNode(" Assign ", -1 /* CACHED */)
                      ]))], 8 /* PROPS */, _hoisted_24)
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}